import type SessionService from '@efdigital/ll-addon-auth/services/session';
import type CoachService from '@efdigital/ll-xceed-v2/services/coach';
import type PartnershipMessagingService from '@efdigital/ll-xceed-v2/services/partnership-messaging';
import { loadCoachPartnershipConversations } from '@efdigital/ll-xceed-v2/utils/coaching/load-partnership-conversations';
import {
  type PartnershipConversation,
  sortConversationsByRecency,
} from '@efdigital/ll-xceed-v2/utils/coaching/partnership-messages';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type CoachingCoachMessagesModel = {
  conversations: PartnershipConversation[];
};

export default class CoachingCoachMessagesRoute extends Route<CoachingCoachMessagesModel> {
  @service declare coach: CoachService;
  @service declare partnershipMessaging: PartnershipMessagingService;
  @service declare session: SessionService;
  @service declare store: Store;

  async model(): Promise<CoachingCoachMessagesModel> {
    // The parent coach route's afterModel already synced this scope's
    // conversations — reuse them instead of fetching the same data again.
    if (
      this.partnershipMessaging.role === 'coach' &&
      this.partnershipMessaging.scopeKey === 'coach' &&
      this.partnershipMessaging.conversations.length
    ) {
      return { conversations: this.partnershipMessaging.conversations };
    }

    return {
      conversations: sortConversationsByRecency(
        await loadCoachPartnershipConversations(
          this.store,
          this.coach,
          this.session.cached.userId!
        )
      ),
    };
  }

  afterModel(model: CoachingCoachMessagesModel): void {
    this.partnershipMessaging.sync(model.conversations, 'coach', 'coach');
  }
}
